<template>
  <div class="ccui-home-index">
    <div class="emc-container">
      <div class="top-title">
        关注的商品
      </div>
      <el-tabs
        v-model="activeName"
        @tab-click="handleClick"
        class="el-tabs__customize"
      >
        <el-tab-pane
          v-for="item in tabPaneMap"
          :key="item.name"
          :label="item.label"
          :name="item.name"
          lazy
        >
        </el-tab-pane>
      </el-tabs>

      <div class="top-weap">
        <div style="line-height: 30px;user-select: none;">
          <label v-if="isBatch">
            <el-checkbox
              class="emc-checkbox"
              :indeterminate="isIndeterminate"
              :value="checkAll"
              @change="handleCheckAllChange"
            ></el-checkbox>
            <span class="text">全选</span>
          </label>
        </div>
        <div class="top-weap-right">
          <el-button v-if="!isBatch" @click="batchManage(true)"
            >批量管理</el-button
          >
          <el-button v-if="isBatch" @click="batcDelete">批量删除</el-button>
          <el-button v-if="isBatch" @click="batchManage(false)"
            >取消删除</el-button
          >
          <el-input
            placeholder="请输入商品标题"
            v-model="formDataSearch.skuTitle"
            class="input-with-select"
            clearable
          >
            <el-button slot="append" @click="search">搜索</el-button>
          </el-input>
        </div>
      </div>
      <div class="shop-container">
        <ul>
          <li v-for="(item, key) in tableData" :key="key" class="shop-item">
            <shopContainer
              :goods="item"
              :isBatch="isBatch"
              @delete="handleDelete"
            />
          </li>
        </ul>
      </div>
      <div
        class="ccui-table-footer"
        style="overflow: hidden;"
        v-if="tableData.length > 0"
      >
        <div id="ccui-paging">
          <el-pagination
            :total="totalNum"
            :page-size="pageSizeCode"
            :current-page="pageNoCode"
            :page-sizes="[5, 10, 20, 50, 100, 200, 500]"
            background
            layout="total, sizes, prev, pager, next, jumper"
            popper-class="ccui-paging-page-size-popper"
            @prev-click="handlePrev"
            @next-click="handleNext"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
          <el-button
            class="ccui-pagination-btn"
            size="mini"
            type="default"
            @click="handleSizeChange('none')"
            >确定</el-button
          >
        </div>
      </div>
      <div
        v-else
        style="text-align: center;margin-top: 50px;font-size: 14px;color: #999;"
      >
        暂无数据
      </div>
    </div>
  </div>
</template>

<script>
import shopContainer from "./components/shopContainer.vue";
import { getFocusSkuPageList, deleteFocusSkuInfo } from "@/api/emc-api";
export default {
  name: "ListContainer",
  data() {
    return {
      activeName: "1",
      tabPaneMap: [
        {
          name: "1",
          label: "全部"
        },
        {
          name: "2",
          label: "有货商品"
        },
        {
          name: "3",
          label: "无货商品"
        },
        {
          name: "4",
          label: "下架商品"
        },
        {
          name: "5",
          label: "30天前加购"
        }
      ],
      isBatch: false,
      // checkAll: false,
      totalNum: 0,
      pageSizeCode: 10,
      pageNoCode: 1,
      formDataSearch: {
        skuTitle: ""
      },
      tableData: []
    };
  },

  components: {
    shopContainer
  },

  computed: {
    isIndeterminate() {
      const selectedItems = this.tableData.filter(item => item.isSelected);
      return (
        selectedItems.length > 0 && selectedItems.length < this.tableData.length
      );
    },
    checkAll() {
      return (
        this.tableData.length > 0 &&
        this.tableData.every(item => item.isSelected)
      );
    }
  },

  created() {
    document.title = "我的关注 - 中交云采";
    this.init();
  },
  mounted() {},

  methods: {
    init() {
      this.isBatch = false;
      this.getList({});
    },
    handleClick(tab) {
      this.pageNoCode = 1;
      this.tableData = [];
      this.init();
    },
    handleDelete(row) {
      this.deleteFocusSkuInfo([row.skuId]);
    },
    deleteFocusSkuInfo(skuIds) {
      deleteFocusSkuInfo({ skuIds: skuIds })
        .then(res => {
          if (res.data.code == "0") {
            this.$message({
              message: res.data.message,
              type: "success",
              showClose: true,
              ccuiCustom: true
            });
            this.init();
          }
        })
        .catch(err => {});
    },
    search() {
      this.pageNoCode = 1;
      this.getList(this.formDataSearch);
    },
    // 列表数据请求
    getList(reqObj) {
      let obj = {};
      obj = typeof reqObj == "object" ? reqObj : obj;
      obj = JSON.parse(JSON.stringify(obj));
      obj.pageNo = this.pageNoCode;
      obj.pageSize = this.pageSizeCode;
      getFocusSkuPageList({
        ...obj,
        searchType: this.activeName,
        isShowPageLoading: true
      })
        .then(res => {
          this.tableData = res.data.data.rows.map(v => {
            v.isSelected = false;
            return v;
          });
          this.totalNum = res.data.data.recordsTotal;
          this.total = res.data.data.recordsTotal;
          this.pageNoCode = res.data.data.pageNo;
        })
        .catch(err => {});
    },
    handleCheckAllChange(value) {
      console.log("handleCheckAllChange", value);
      this.tableData = this.tableData.map(v => {
        v.isSelected = value;
        return v;
      });
    },

    batcDelete() {
      const skuIds = this.tableData
        .filter(item => item.isSelected)
        .map(item => item.skuId);
      if (skuIds.length == 0) {
        return this.$message({
          message: "请选中商品，再删除！",
          type: "error",
          showClose: true,
          ccuiCustom: true
        });
      }
      this.$confirm("确认删除已关注的商品吗？", "提示", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "ccui-message-box-custom"
      })
        .then(() => {
          console.log("确定");
          this.deleteFocusSkuInfo(skuIds);
        })
        .catch(() => {
          console.log("取消");
        });
    },
    handlePrev() {},
    handleNext() {},
    // 每页条数发生改变
    handleSizeChange(val) {
      this.pageNoCode = 1;
      if (val !== "none") {
        this.pageSizeCode = val;
      }
      this.getList(this.formDataSearch);
    },
    // 当前页发生改变
    handleCurrentChange(val) {
      // 跳转翻页都会调这个方法
      this.pageNoCode = val;
      this.getList(this.formDataSearch);
    },

    batchManage(val) {
      this.isBatch = val;
      this.tableData = this.tableData.map(v => {
        v.isSelected = false;
        return v;
      });
    }
  },

  watch: {}
};
</script>
<style lang="scss" scoped>
.emc-container {
  min-height: 600px;
}
.top-weap {
  display: flex;
  justify-content: space-between;
  .text {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #4a4a4a;
    line-height: 20px;
    text-align: left;
    font-style: normal;
  }
  .el-checkbox {
    margin-right: 10px;
    margin-left: 0;
  }
  .top-weap-right {
    .input-with-select {
      width: 300px;
      height: 30px;
      margin-left: 10px;
      /deep/.el-input-group__append {
        border: none;
      }
      /deep/ .el-input__inner {
        border-color: #ff142f !important;
        border-radius: 0px;
        margin-top: 1px;
      }
      .el-button {
        border-radius: 0px;
        span {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 13px;
          color: #ffffff;
          line-height: 18px;
          text-align: left;
        }
      }
      .el-input-group__append button.el-button,
      .el-input-group__append div.el-select .el-input__inner,
      .el-input-group__append div.el-select:hover .el-input__inner,
      .el-input-group__prepend button.el-button,
      .el-input-group__prepend div.el-select .el-input__inner,
      .el-input-group__prepend div.el-select:hover .el-input__inner {
        background-color: #ff142f !important;
        color: #ffffff;
      }
    }
  }
}
.shop-container {
  margin-top: 15px;
  ul {
    display: flex;
    // width: 1180px;
    flex-wrap: wrap;
    li {
      margin-bottom: 10px;
      width: calc(20% - 8px);
    }
  }
}
.shop-footer {
  display: flex;
  justify-content: end;
  width: 100%;
  margin-top: 40px;
}
.top-title {
  font-size: 16px;
  color: #4a4a4a;
  font-weight: bold;
}
/deep/ .el-tabs__customize {
  margin-top: 15px;
  .el-tabs__nav-wrap {
    .el-tabs__item:not(.is-active) {
      font-weight: normal;
    }
    &:after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 2px;
      background-color: #f1f1f1;
      z-index: 1;
    }
  }
}
.shop-item {
  margin-right: 10px;
  &:nth-of-type(5n) {
    margin-right: 0;
  }
}
/deep/.el-checkbox__inner {
  width: 20px;
  height: 20px;
}
/deep/.el-checkbox__inner::after {
  border-width: 2px;
  height: 12px;
  width: 6px;
  left: 5px;
}
/deep/.el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
  height: 2px;
  left: 3px;
  right: 3px;
  top: 8px;
  transform: scale(1);
}
</style>
